// 查詢筆數的上限數量
export const SEARCH_MAX_COUNT = 10000
